import { AppSettings } from "@nordpoolgroup/nps-angular-2-common";

export class ContractManagementAppSettings extends AppSettings {
}



// WEBPACK FOOTER //
// ./src/app/ContractManagementAppSettings.ts